import React from 'react'

type Props = {
  width?: number
  height?: number
}

export function CardsIconJcb({ width = 32, height = 24 }: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.7452 19.1544C31.7452 21.8302 29.5765 24 26.8998 24H0.592773V4.84635C0.592773 2.1698 2.76161 0 5.43867 0H31.745L31.745 19.1543L31.7452 19.1544Z"
        fill="white"
      />
      <path
        d="M23.1689 12.4201C23.9203 12.4364 24.6759 12.3869 25.4243 12.4458C26.1822 12.5872 26.3649 13.7345 25.6915 14.1103C25.2321 14.3579 24.6863 14.2025 24.1883 14.2462H23.1689V12.4201ZM25.8588 10.3531C26.0257 10.9424 25.4577 11.4714 24.8902 11.3903H23.1689C23.1809 10.8346 23.1453 10.2315 23.1863 9.70506C23.8759 9.72448 24.5718 9.66545 25.2574 9.73593C25.5519 9.80994 25.7985 10.0521 25.8588 10.3531ZM30.0013 1.61479C30.0333 2.7401 30.0059 3.92489 30.0151 5.07303C30.013 9.74094 30.0196 14.4087 30.0115 19.0769C29.9812 20.8263 28.4308 22.3464 26.6935 22.3813C24.9545 22.3884 23.2153 22.3824 21.476 22.3844V15.3274C23.371 15.3177 25.267 15.3473 27.1612 15.3127C28.0399 15.2575 29.0024 14.6777 29.0433 13.7107C29.1468 12.7395 28.2311 12.0678 27.3618 11.9617C27.0276 11.953 27.0374 11.8643 27.3618 11.8255C28.1909 11.6463 28.842 10.7882 28.5981 9.92876C28.3902 9.02483 27.3911 8.67498 26.5601 8.67672C24.8657 8.66521 23.1709 8.67511 21.4764 8.67176C21.4873 7.35432 21.4536 6.03547 21.4946 4.71899C21.6289 3.00116 23.2183 1.5845 24.9312 1.61524C26.6214 1.61498 28.3114 1.61498 30.0013 1.61492V1.61479Z"
        fill="url(#paint0_linear_63481_183762)"
      />
      <path
        d="M2.32779 4.89723C2.37106 3.15059 3.92808 1.64295 5.66315 1.61742C7.39571 1.61209 9.12853 1.61665 10.8611 1.61511C10.8563 7.459 10.8705 13.3035 10.854 19.1471C10.7872 20.8725 9.24716 22.3514 7.531 22.382C5.79516 22.3883 4.05912 22.3829 2.32322 22.3846V15.0898C4.00936 15.4881 5.77754 15.6577 7.49769 15.3935C8.52591 15.228 9.6509 14.7231 9.99902 13.6564C10.2552 12.7439 10.111 11.7836 10.1491 10.847V8.67208H7.1722C7.15883 10.1105 7.1996 11.5515 7.15066 12.9882C7.07042 13.8713 6.19587 14.4324 5.363 14.4024C4.33008 14.4134 2.28322 13.6538 2.28322 13.6538C2.27808 10.9588 2.31319 7.58362 2.32779 4.89749V4.89723Z"
        fill="url(#paint1_linear_63481_183762)"
      />
      <path
        d="M11.9715 9.54919C11.8148 9.58243 11.94 9.01544 11.9 8.80035C11.9106 7.44041 11.8777 6.07899 11.9182 4.72001C12.052 2.99491 13.6537 1.57472 15.3735 1.6151H20.4383C20.4335 7.45899 20.4476 13.3035 20.4312 19.1471C20.3643 20.8725 18.8242 22.3514 17.1079 22.382C15.372 22.3885 13.6359 22.383 11.8999 22.3847V14.3922C13.0855 15.365 14.697 15.5164 16.1741 15.519C17.2876 15.5187 18.3946 15.347 19.476 15.0902V13.6259C18.2574 14.2333 16.8248 14.6191 15.4738 14.2702C14.5314 14.0356 13.8474 13.1248 13.8626 12.1523C13.7534 11.1409 14.3463 10.0732 15.3401 9.7725C16.5741 9.38619 17.919 9.68165 19.0757 10.1839C19.3235 10.3137 19.5751 10.4746 19.476 10.0604V8.90947C17.5415 8.44921 15.4827 8.27985 13.5392 8.78055C12.9766 8.93924 12.4285 9.17992 11.9715 9.54932V9.54919Z"
        fill="url(#paint2_linear_63481_183762)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_63481_183762"
          x1="21.4177"
          y1="11.5555"
          x2="29.9613"
          y2="11.5555"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#007B40" />
          <stop offset="1" stopColor="#55B330" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_63481_183762"
          x1="2.14157"
          y1="12.1988"
          x2="10.7211"
          y2="12.1988"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1D2970" />
          <stop offset="1" stopColor="#006DBA" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_63481_183762"
          x1="11.8874"
          y1="11.757"
          x2="20.4367"
          y2="11.757"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6E2B2F" />
          <stop offset="1" stopColor="#E30138" />
        </linearGradient>
      </defs>
    </svg>
  )
}
